import { usePublishedContext } from '@/components/views/published/PublishedContext';
import { useItemHealth, useItemHealthById } from '@/lib/queries/dashboard/useItemHealth';

export const useItemProgressWithPublished = ({
  itemId,
  itemIds,
  enabled = true,
}: {
  itemId: number;
  itemIds: number[];
  enabled?: boolean;
}) => {
  const publishedContext = usePublishedContext();

  const { isLoading: isHealthLoading } = useItemHealth({
    itemIds,
    enabled: publishedContext === null && enabled,
  });
  const { data: itemHealthData } = useItemHealthById({
    itemId,
    enabled: publishedContext === null && enabled,
  });

  if (publishedContext !== null) {
    const panelData = publishedContext.getItemPanelData(itemId);
    return { progressPercentage: panelData?.progress ?? 0, isLoading: false };
  }

  return {
    progressPercentage: Math.round(itemHealthData?.progress ?? 0),
    isLoading: isHealthLoading,
  };
};
